import axios from 'axios';
import config from '../../config';
import { DropdownOption } from '../types';

interface DirectSupplyClient {
    id: number;
    name: string;
}

export const getDirectSupplyClients = async (): Promise<DropdownOption[]> => {
    const { data } = await axios.get<DirectSupplyClient[]>(
        `${config.apiBaseUrl}/Clients/directSupplyEnabled`
    );

    return data.map(({ id, name }) => ({ value: String(id), label: name }));
};
